
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    iconContainer: {
        padding: 6,
        borderRadius: '100%',
        display: 'flex',
        width: 'max-content'
    },
    iconNotSelected: {
        color: 'gray',
        border: '3px dashed rgba(0, 0, 0, 0.12)'
    },
    iconSelected: {
        color: theme.palette.primary.contrastText,
        border: `3px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.main,
    },
    iconWarning: {
        color: theme.palette.error.contrastText,
        border: `3px solid ${theme.palette.error.main}`,
        backgroundColor: theme.palette.error.main,
    },
    cardArea: {
        maxHeight: '53px',
        padding: theme.spacing(1, 1),
        '& span': {
            lineHeight: 1.6
        }
    },
    cardAreaHigh: {
        maxHeight: '106px',
        padding: theme.spacing(1, 1),
        '& span': {
            lineHeight: 1.6
        }
    },
    cardAreaDisabled: {
        opacity: 0.5,
        pointerEvents: 'none'
    },
    observationContent:{
        width: '20rem'
    }
}))

export default useStyles;